import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from '../41e3e4ef74b344163f6f9c634823f771533dce8ee2dfa33ad6af214c7fd67517.cfe-internal.js';
import wrapEvent from '../../../utils/wrapEvent/23c80f7add1e49cb7ec4f51c7147fefad38efa28a6c83d021f7f4e40fcc22e85.cfe-internal.js';
import Checkbox from '../../Checkbox/c7a6f674bdbe7311b6ab06d2994c348192e3ca9a9995fd933cd66c1b347ddfed.cfe-internal.js';

var _excluded = ["role", "tabIndex", "children", "className", "disabled", "onSelect", "onKeyDown", "onClick", "isSelected", "isHighlighted", "isMultiSelect", "isSelectable"];
var MenuItem = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _classNames;

  var role = _ref.role,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? -1 : _ref$tabIndex,
      label = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      onKeyDown = _ref.onKeyDown,
      onClick = _ref.onClick,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isHighlighted = _ref.isHighlighted,
      isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
      _ref$isMultiSelect = _ref.isMultiSelect,
      isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      rest = _objectWithoutProperties(_ref, _excluded);

  var defaultRole = isSelectable ? isMultiSelect ? 'menuitemcheckbox' : 'menuitemradio' : 'menuitem';

  var handleSelect = function handleSelect(e) {
    if (typeof onSelect === 'function' && !disabled) {
      onSelect(e);
    }
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", _extends({}, rest, {
      ref: ref,
      role: role !== null && role !== void 0 ? role : defaultRole,
      tabIndex: tabIndex,
      "aria-disabled": disabled,
      "aria-checked": isSelectable ? isSelected : undefined,
      className: classNames(className, styles.menuItem, (_classNames = {}, _defineProperty(_classNames, styles.focus, isHighlighted), _defineProperty(_classNames, styles.selected, isSelected), _classNames)),
      onKeyDown: wrapEvent(onKeyDown, function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          handleSelect(e);
          e.preventDefault(); // prevent scroll
        }
      }),
      onClick: wrapEvent(onClick, handleSelect)
    }), isMultiSelect && /*#__PURE__*/React__default.createElement(Checkbox, {
      "aria-hidden": true,
      className: classNames(styles.checkbox, _defineProperty({}, styles.highlighted, isHighlighted && !isSelected)),
      checked: isSelected,
      onChange: function onChange() {
        /* noop*/
      }
    }), label)
  );
});
var MenuItem$1 = MenuItem;

export { MenuItem$1 as default };
